import { Error } from '@mui/icons-material'
import AccessTimeIcon from '@mui/icons-material/AccessTime'
import RemoveIcon from '@mui/icons-material/Remove'
import React from 'react'
import CancelIcon from '@mui/icons-material/Cancel'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import { determineTooltipDetails, gatherModelWarnings } from 'utils/warnings'
import WarningIcon from 'components/WarningTooltip'
import { PROCESS_STATUS } from 'utils/constants/kypStatuses'
import { buildQuodScore, buildScore } from '../../../utils/functions'
import { BGC_FIELDS } from '../../../utils/constants/bgcFields'
import { ITEM_STATUS } from '../../../utils/constants/application'
import Colors from '../../../utils/Colors'
import styles from './styles'

const BuildBgcRowFields = (summary, excludedFields) => {
  const classes = styles()

  const getIcon = (bgcStatus, status, consists) => {
    if (bgcStatus === PROCESS_STATUS.ERROR) {
      return <RemoveIcon style={{ color: Colors.gray }} />
    }
    if (status === ITEM_STATUS.processing)
      return <AccessTimeIcon style={{ color: Colors.gray }} />
    switch (consists) {
      case true:
        return <CancelIcon style={{ color: Colors.red }} />
      case false:
        return <CheckCircleIcon style={{ color: Colors.green }} />
      default:
        return <RemoveIcon style={{ color: Colors.gray }} />
    }
  }

  const buildBgcRiskScore = () => {
    if (summary.status === PROCESS_STATUS.ERROR) {
      return <RemoveIcon style={{ color: Colors.gray }} />
    }
    if (summary?.is_score_inconsistent) {
      return <Error style={{ color: Colors.orange }} />
    }
    if (!summary?.is_score_complete) {
      return <AccessTimeIcon style={{ color: Colors.gray }} />
    }
    return summary?.risk_score != null ? (
      <div className={classes.score} style={buildScore(summary.risk_score)}>
        {summary.risk_score}
      </div>
    ) : (
      <div>
        <RemoveIcon style={{ color: Colors.gray }} />
      </div>
    )
  }

  const buildBgcCreditScoreData = (field) => {
    const data = summary[field]

    if (data == null) {
      return <AccessTimeIcon style={{ color: Colors.gray }} />
    }

    return <div className={classes.score} style={buildQuodScore(summary[field]?.quod_score)}>
      {summary[field]?.quod_score}
    </div>
  }

  if (!summary) {
    return (
      <td>
        <AccessTimeIcon style={{ color: Colors.gray }} />
      </td>
    )
  }
  try {
    return Object.keys(BGC_FIELDS).map((field) => {
      if (excludedFields.includes(field)) {
        return null
      }

      const key = `${field}_${summary.uuid}`
      
      const result = gatherModelWarnings(summary[field])
      if (result.anyWarning) {
        const tooltipDetails = determineTooltipDetails(result)
        return (
          <td key={key}>
            <WarningIcon
              message={tooltipDetails.message}
              color={tooltipDetails.color}
              />
          </td>
        )
      }
      
      if (field === BGC_FIELDS.risk_score) {
        return <td key={key}>{buildBgcRiskScore()}</td>
      }
      if (field === BGC_FIELDS.credit_score_data) {
        return <td key={key}>{buildBgcCreditScoreData(field)}</td>
      }

      return (
        <td key={key}>
          {getIcon(
            summary.status,
            summary[field]?.status,
            summary[field]?.consists,
          )}
        </td>
      )
    })
  } catch (err) {
    return <td>N/A</td>
  }
}

export default BuildBgcRowFields
